import { render, staticRenderFns } from "./SubmittedListFilter.vue?vue&type=template&id=a1e4cf6c&"
import script from "./SubmittedListFilter.vue?vue&type=script&lang=js&"
export * from "./SubmittedListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports